import { render, staticRenderFns } from "./companylist.vue?vue&type=template&id=5a99d5a4&"
import script from "./companylist.vue?vue&type=script&lang=js&"
export * from "./companylist.vue?vue&type=script&lang=js&"
import style0 from "./companylist.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "companylist.vue"
export default component.exports